import { useCallback, useEffect, useState } from "react";

function readStored(storageKey: string): string | null {
    try {
        return window.localStorage.getItem(storageKey);
    } catch {
        return null;
    }
}

/** Booleano com preferencia em localStorage; le apos montar para nao divergir do SSR. */
export function usePersistedBoolean(storageKey: string, fallback = false): [boolean, (value: boolean) => void] {
    const [value, setValue] = useState(fallback);

    useEffect(() => {
        const stored = readStored(storageKey);
        if (stored !== null) setValue(stored === "true");
    }, [storageKey]);

    const update = useCallback(
        (next: boolean) => {
            setValue(next);
            try {
                window.localStorage.setItem(storageKey, String(next));
            } catch {
                // Storage bloqueado: a preferencia vale so nesta sessao.
            }
        },
        [storageKey]
    );

    return [value, update];
}
